import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CronosPopoverPage } from './cronos-popover';

@NgModule({
  declarations: [
    CronosPopoverPage,
  ],
  imports: [
    IonicPageModule.forChild(CronosPopoverPage),
  ],
})
export class CronosPopoverPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cronos-popover/cronos-popover.module.ts